import React, { useEffect, useState, useRef } from "react";

const DABANGA_AR_FEED = "https://www.dabangasudan.org/ar/all-news/feed/";
const RSS2JSON = `https://api.rss2json.com/v1/api.json?rss_url=${encodeURIComponent(DABANGA_AR_FEED)}&count=15`;

const CACHE_KEY = "spar-ticker-cache-v2";
const CACHE_TTL = 4 * 60 * 60 * 1000;

function loadCache() {
  try {
    const raw = sessionStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const { ts, items } = JSON.parse(raw);
    if (Date.now() - ts > CACHE_TTL) return null;
    return items;
  } catch {
    return null;
  }
}

function saveCache(items) {
  try {
    sessionStorage.setItem(CACHE_KEY, JSON.stringify({ ts: Date.now(), items }));
  } catch {}
}

const FALLBACK = [
  { title: "راديو دبنقا — صوت السودان المستقل",     link: "https://www.dabangasudan.org/ar/" },
  { title: "أخبار السودان — متابعة مستمرة",          link: "https://www.dabangasudan.org/ar/all-news" },
  { title: "SPAR Hub — تجمّع التشكيليين السودانيين", link: "https://spar-hub.org" },
  { title: "سجّل الدخول وشارك في منتدى SPAR",        link: "https://spar-hub.org/Forum" },
];

export default function NewsTicker() {
  const [items, setItems] = useState(loadCache() || FALLBACK);
  const trackRef          = useRef(null);
  const posRef            = useRef(0);
  const pausedRef         = useRef(false);

  useEffect(() => {
    if (loadCache()) return;
    fetch(RSS2JSON)
      .then(r => r.json())
      .then(data => {
        if (data.status === "ok" && data.items?.length) {
          const fetched = data.items
            .filter(i => i.title && i.link)
            .map(i => ({ title: i.title, link: i.link }));
          setItems(fetched);
          saveCache(fetched);
        }
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    let raf;
    const speed = 0.6;

    function step() {
      if (!pausedRef.current) {
        posRef.current -= speed;
        const totalW = track.scrollWidth / 2;
        if (Math.abs(posRef.current) >= totalW) posRef.current = 0;
        track.style.transform = `translateX(${posRef.current}px)`;
      }
      raf = requestAnimationFrame(step);
    }

    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [items]);

  const doubled = [...items, ...items];

  return (
    <div style={{
      position: "fixed",
      top: 0, left: 0, right: 0,
      height: 46,
      zIndex: 1001,
      background: "#12100E",
      display: "flex",
      alignItems: "center",
      overflow: "hidden",
      borderBottom: "1px solid rgba(192,57,43,0.3)",
      direction: "rtl",
    }}>
      {/* Label */}
      <a
        href="https://www.dabangasudan.org/ar/"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          flexShrink: 0,
          background: "#C0392B",
          color: "#fff",
          fontFamily: "Cairo, Arial, sans-serif",
          fontWeight: 700,
          fontSize: 13,
          padding: "0 20px 0 28px",
          height: "100%",
          display: "flex",
          alignItems: "center",
          whiteSpace: "nowrap",
          clipPath: "polygon(0 0, 100% 0, 88% 100%, 0 100%)",
          zIndex: 1,
          letterSpacing: "0.02em",
          textDecoration: "none",
        }}
      >
        دبنقا · أخبار
      </a>

      {/* Scrolling track */}
      <div
        style={{ flex: 1, overflow: "hidden", height: "100%", display: "flex", alignItems: "center" }}
        onMouseEnter={() => { pausedRef.current = true; }}
        onMouseLeave={() => { pausedRef.current = false; }}
      >
        <div
          ref={trackRef}
          style={{
            display: "flex",
            alignItems: "center",
            whiteSpace: "nowrap",
            willChange: "transform",
            gap: 0,
          }}
        >
          {doubled.map((item, i) => (
            <a
              key={i}
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#e0d8d0",
                fontFamily: "Cairo, Arial, sans-serif",
                fontSize: 13,
                fontWeight: 500,
                paddingLeft: 48,
                paddingRight: 8,
                display: "inline-flex",
                alignItems: "center",
                gap: 10,
                textDecoration: "none",
                transition: "color 0.15s",
              }}
              onMouseEnter={e => { e.currentTarget.style.color = "#C0392B"; }}
              onMouseLeave={e => { e.currentTarget.style.color = "#e0d8d0"; }}
            >
              <span style={{ color: "#C0392B", flexShrink: 0 }}>◆</span>
              {item.title}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
